import news from '@/assets/icons/menu/1.svg?inline'
import catalog from '@/assets/icons/menu/2.svg?inline'
import material from '@/assets/icons/menu/3.svg?inline'
import service from '@/assets/icons/menu/4.svg?inline'
import contact from '@/assets/icons/menu/5.svg?inline'
import users from '@/assets/icons/menu/6.svg?inline'
import partnership from '@/assets/icons/menu/7.svg?inline'
export default {
    methods: {
    },
    components: {news, catalog, material, service, contact,
        users, partnership
    },
    computed: {
        nameRout() {
            return this.$route.name;
        },
        infoPage() {
            return this.navigationInfo.find(item => item.name === this.nameRout);
        },
        navigationInfo() {
            return [
                {
                    id: 0,
                    name: 'services',
                    text: 'Услуги',
                    icon: service

                },
                {
                    id: 1,
                    name: 'material',
                    text: 'Материалы',
                    icon: material
                },
                {
                    id: 2,
                    name: 'academy',
                    text: 'Академия',
                    icon: catalog
                },
                {
                    id: 3,
                    name: 'partners',
                    text: 'Партнеры',
                    icon: contact
                },
                {
                    id: 4,
                    name: 'partnership',
                    text: 'Партнерство',
                    icon: partnership
                },
                {
                    id: 5,
                    name: 'tags',
                    text: 'Библиотека тегов',
                    icon: service
                },
                {
                    id: 6,
                    name: 'client-logos',
                    text: 'Логотипы клиентов',
                    icon: contact
                },

            ]
        }
    },
}